import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../Redux/Store';
import Toast from './Toast';

const ToastContainer: React.FC = () => {
  const toasts = useSelector((state: RootState) => state.ToastSlice.toasts);

  return (
    <div aria-live="assertive" className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-[99999]">
      <div className="w-full flex flex-col items-center space-y-4 sm:items-end z-[99999]">
        {toasts.map((toast) => (
          <Toast key={toast.id} toast={toast} />
        ))}
      </div>
    </div>
  );
};

export default ToastContainer;